module.exports = __webpack_public_path__ + "static/media/pinme3.b8a93f1c.gif";